module.exports = __webpack_public_path__ + "static/media/728x150.4ba88e01.png";